export class ChannelSubscriptionCounter {
    state: Record<string, number> = {}

    inc(channelName: string) {
        if (!this.state[channelName]) {
            this.state[channelName] = 1;
        }
        else {
            this.state[channelName]++;
        }
    }

    dec(channelName: string) {
        if (this.state[channelName]) {
            this.state[channelName]--;
        }
    }

    hasSubscriptions(channelName: string) {
        return !!this.state[channelName];
    }

    hasChannel(channelName: string) {
        return Object.prototype.hasOwnProperty.call(this.state, channelName);
    }

    removeSubscription(channels: string[]) {
        channels.forEach(channel => {
            delete this.state[channel];
        })
    }

    clear() {
        this.state = {};
    }
}
